import { render, staticRenderFns } from "./AircraftLogs.vue?vue&type=template&id=6873df50&"
import script from "./AircraftLogs.vue?vue&type=script&lang=js&"
export * from "./AircraftLogs.vue?vue&type=script&lang=js&"
import style0 from "./AircraftLogs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6873df50')) {
      api.createRecord('6873df50', component.options)
    } else {
      api.reload('6873df50', component.options)
    }
    module.hot.accept("./AircraftLogs.vue?vue&type=template&id=6873df50&", function () {
      api.rerender('6873df50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AircraftLogs.vue"
export default component.exports